import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { Component, Inject, OnInit } from '@angular/core';
import { User } from 'src/app/model/user';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { RequestService } from 'src/app/services/request.service';
import { SnackService } from 'src/app/services/snack.service';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import { NotificationMailRequestBody } from './notification-mail-request-body';
import { Project } from 'src/app/model/project/project';

@Component({
  selector: 'notification-mail',
  templateUrl: './notification-mail.component.html',
  styleUrls: ['./notification-mail.component.scss'],
})
export class NotificationMailComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  private static readonly PROJECT_RECIPIENT: Recipient = {
    firstName: 'Project',
    lastName: 'Inpress',
    email: 'project@inpress.be',
  };
  private static readonly QUOTATION_RECIPIENT: Recipient = {
    firstName: 'Offerte',
    lastName: 'Inpress',
    email: 'offerte@inpress.be',
  };
  private static readonly TOON_VANBILSEN: Recipient = {
    firstName: 'Toon',
    lastName: 'Vanbilsen',
    email: 'toon@inpress.be',
  };

  userOptions: User[];
  project: Project;
  subProjectId: number;
  actionInfo: string;
  showQuotationAddress: boolean;

  selectAll: boolean;
  performSend: boolean;
  recipientOptions: Recipient[];
  selectedRecipients: Recipient[];

  init: boolean = false;
  sending: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<NotificationMailComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private requestService: RequestService,
    private snackService: SnackService
  ) {
    super();
    this.userOptions = data.userOptions;
    this.project = data.project;
    this.subProjectId = data.subProjectId;
    this.showQuotationAddress = data.showQuotationAddress;
    this.selectAll = data.selectAll;
    this.performSend = data.performSend;
  }

  ngOnInit() {
    this.recipientOptions = this.userOptions.map((u) => {
      return {
        firstName: u.firstName,
        lastName: u.lastName,
        email: u.email,
        id: u.id,
      };
    });
    this.selectedRecipients = this.selectAll ? [...this.recipientOptions] : [];
    if (this.showQuotationAddress) {
      this.recipientOptions.push(NotificationMailComponent.QUOTATION_RECIPIENT);
    } else {
      this.recipientOptions.push(NotificationMailComponent.PROJECT_RECIPIENT);
    }
    if (
      !this.recipientOptions.some(
        (o) => o.email === NotificationMailComponent.TOON_VANBILSEN.email
      )
    ) {
      this.recipientOptions.push(NotificationMailComponent.TOON_VANBILSEN);
    }
    this.init = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  actionInfoChanged(value) {
    this.actionInfo = value;
  }

  performAction() {
    const projectRecipientIncluded = this.selectedRecipients.includes(
      NotificationMailComponent.PROJECT_RECIPIENT
    );
    const quotationRecipientIncluded = this.selectedRecipients.includes(
      NotificationMailComponent.QUOTATION_RECIPIENT
    );
    const toonVanBilsenRecipientIncluded = this.selectedRecipients.includes(
      NotificationMailComponent.TOON_VANBILSEN
    );
    if (
      !CollectionHelper.isPopulated(this.selectedRecipients) &&
      !projectRecipientIncluded &&
      !quotationRecipientIncluded &&
      !toonVanBilsenRecipientIncluded
    ) {
      this.snackService.showWarning(
        'Gelieve minstens één ontvanger te selecteren'
      );
      return;
    }
    if (StringHelper.isEmpty(this.actionInfo)) {
      this.snackService.showWarning('Gelieve extra info op te geven');
    }
    const body: NotificationMailRequestBody = {
      project: this.performSend ? null : this.project,
      sendEmail: true,
      sendToProjectsAddress: projectRecipientIncluded,
      sendToQuotationAddress: quotationRecipientIncluded,
      sendToToonVanbilsen: toonVanBilsenRecipientIncluded,
      userRecipients: this.selectedRecipients
        .filter(
          (r) =>
            r != NotificationMailComponent.PROJECT_RECIPIENT &&
            r != NotificationMailComponent.QUOTATION_RECIPIENT &&
            r != NotificationMailComponent.TOON_VANBILSEN
        )
        .map((r) => r.id),
      subProjectId: this.subProjectId,
      actionInfo: this.actionInfo,
    };
    if (this.performSend) {
      this.sending = true;
      this.addSubscription(
        this.requestService.post(body, 'subprojects/sendNotificationEmail'),
        (res) => {
          if (res.success) {
            this.snackService.showSuccess(res.message);
            this.dialogRef.close();
          } else {
            this.sending = false;
            this.snackService.showError(res.message);
          }
        },
        (err) => {
          this.sending = false;
          this.snackService.showError(err);
        }
      );
    } else {
      this.dialogRef.close(body);
    }
  }

  compareRecipients(o1: any, o2: any): boolean {
    return o1 == o2;
  }
}

interface Recipient {
  firstName: String;
  lastName: String;
  email: String;
  id?: number;
}
